document.addEventListener('turbolinks:load', function () {
  $('.new_role, .edit_role').on('submit', function () {
    $('#role_permissions_table').DataTable().search('').draw(false);
  });
});
